import { render, staticRenderFns } from "./UnfinishedTasks.vue?vue&type=template&id=33e83426"
import script from "./UnfinishedTasks.vue?vue&type=script&lang=js"
export * from "./UnfinishedTasks.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports